import { axiosInstance } from "./axiosInstance";
import { ITopic } from "@protoplan/types";
import { enforcePostSpielTypes, enforceSpielCommentTypes } from "../enforceTypes/ref";
import { IPost } from "../../components/Refs/RefsTable";



export async function searchTopics(value: string)
{
  return axiosInstance.post("/refs/search", { "Search-terms": value })
    .then(resJson => resJson.data)
    .catch(error => console.log("Error searching topics:", error));
}

export async function getTopic(topicId: number)
{
  return axiosInstance.post("/refs/topic", { topicId })
    .then(resJson => resJson.data as ITopic)
    .catch(error => console.log("Error getting topic with topicId " + topicId + ":", error));
}

export async function getSpiels(topicId: number)
{
  return axiosInstance.post("/refs/getSpiels", { "Topic-id": topicId })
    .then(resJson =>
    {
      const data = resJson.data as IPost[];
      return enforcePostSpielTypes(data);
    })
    .catch(error => console.log("Error getting refs for topicId", topicId + ":",  error));
}

export async function getSubtopics(topicId: number)
{
  return axiosInstance.post("/refs/subtopics", { "Topic-id": topicId })
    .then(resJson => resJson.data)
    .catch(error => console.log("Error retrieving subtopics for topicId " + topicId + ":", error));
}

export async function getBooks()
{
  return axiosInstance.post("/refs/books")
    .then(resJson => resJson.data as { bookId: number, title: string, bookFormatId: number }[])
    .catch(error => console.log("Error retrieving books:", error));
}

export async function getBookFormats()
{
  return axiosInstance.post("/refs/bookFormats")
    .then(resJson => resJson.data as { bookFormatId: number, name: string }[])
    .catch(error => console.log("Error retrieving book formats:", error));
}

export async function getPlatforms()
{
  return axiosInstance.post("/refs/platforms")
    .then(resJson => resJson.data as { platformId: number, name: string }[])
    .catch(error => console.log("Error retrieving platforms:", error));
}

export async function getPosts(platformId: number)
{
  return axiosInstance.post("/refs/posts", { "Platform-id": platformId })
    .then(resJson => resJson.data as { postId: number, title: string, date: Date }[])
    .catch(error => console.log("Error retrieving posts:", error));
}

export async function postNewBookRef(
  topicId: number,
  bookId: number,
  pageNo?: number,
  timestamp?: string)
{
  return axiosInstance.post("/refs/newBookRef", {
    topicId,
    bookId,
    pageNo,
    timestamp })
    .catch(error => console.log("Error submitting new book ref:", error));
}

export async function postNewPostRef(topicId: number, postId: number, timestamp?: string)
{
  return axiosInstance.post("/refs/newPostRef", {
    "Topic-id": topicId,
    "Post-id": postId,
    "Timestamp": timestamp })
    .catch(error => console.log("Error submitting new post ref:", error));
}

export async function postNewPost(platformId: number, postId: number, title: string, date: Date, url: string)
{
  return axiosInstance.post("/refs/newPost", {
    "Platform-id": platformId,
    "Post-id": postId,
    "Title": title,
    "Date": date,
    "Url": url })
    .catch(error => console.log("Error submitting new post:", error));
}

export async function postNewRefVote(postRefId: number)
{
  return axiosInstance.post("/refs/newRefVote", { "Post-ref-id": postRefId })
    .catch(error => console.log("Error submitting new post ref vote:", error));
}

export async function postNewPostRefComment(postRefId: number, text: string)
{
  return axiosInstance.post("/refs/newRefComment", { "Post-ref-id": postRefId, "Text": text })
    .then(resJson => ({ ...resJson.data, time: new Date(resJson.data.time) }))
    .catch(error => console.log("Error submitting new post ref comment:", error));
}

export async function postUpdatedPostRefComment(postRefCommentId: number, text: string)
{
  return axiosInstance.post("/refs/updatePostRefComment", {
    "Post-ref-comment-id": postRefCommentId,
    "Text": text  })
    .then(resJson => ({ editedTime: new Date(resJson.data.editedTime) }))
    .catch(error => console.log("Error submitting updated post ref comment:", error));
}

export async function deletePostRefComment(postRefCommentId: number)
{
  console.log("deletePostRefComment", postRefCommentId);
  return axiosInstance.post("/refs/removeRefComment", { "Post-ref-comment-id": postRefCommentId })
    .catch(error => console.log("Error deleting post ref vote:", error));
}

export async function postNewPostRefCommentVote(postRefCommentId: number)
{
  return axiosInstance.post("/refs/newRefCommentVote", { "Post-ref-comment-id": postRefCommentId })
    .catch(error => console.log("Error submitting new post ref comment vote:", error));
}

export async function getSpielComments(postRefId: number)
{
  return axiosInstance.post("/refs/spielComments", { "Post-ref-id": postRefId })
    .then(resJson => enforceSpielCommentTypes(resJson.data.comments))
    .catch(error => console.log("Error getting spiel comments:", error));
}

export async function getTwitterEmbedHtml(url: string, widgetType = 'video')
{
  return axiosInstance.post("/refs/twitterEmbedHtml", { url, widgetType })
    .then(resJson => resJson.data.html)
    .catch(error => console.log("Error getting Twitter Embed Html:", error));
}
